//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";

export default {
    name: "clientTimeLineStatus",
    data(vm) {
        return {
            dialogAdd: false,
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            id_del: 0,
            search: "",
            leave_type: "",
            dialogDelete: false,
            authorize_view: false,
            authorize_add: false,
            authorize_edit: false,
            authorize_del: false,
            toggleEnable: false,
            selectstatus: "",
            mDataArray: [],
            authorize: [],
            headers: [

                {
                    text: "",
                    value: "actions",
                    align: "center",
                    class: "bg-colorth tabletextwhite",
                    divider: true,
                },
                {
                    text: "Status",
                    value: "status",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Color",
                    value: "color",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Icon",
                    value: "icon",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Icon Color",
                    value: "icon_color",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },

            ],
            dialogAddData: false,
            dataItem: {},
            modeActions: "",
        };
    },
    async beforeCreate() {
        console.log("beforeCreate");
        this.$store.state.navMenu = true;
    },
    beforeUpdate() { },
    components: {
        SuccessDialog,
        SuccessDialogPush,
    },
    computed: {
        itemsForSelected() {
            if (this.search.length) {
                return this.dataSource.filter((item) => this.search.includes(item));
            }
            return this.dataSource;
        },
    },
    async mounted() {
        // await api.checkVersion();
        // this.userId = localStorage.getItem(server.USER_ID);
        // let yourUrlString = window.location;

        // let parser = document.createElement("a");
        // parser.href = yourUrlString;

        // this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

        // // alert("authorize_id:" + this.authorize_id);
        // if (this.authorize_id == null || this.authorize_id == 0) {
        //     // this.$router.push("/login");
        //     this.$store.state.global_dialog = true;
        //     this.setupAlertDialog(
        //         true,
        //         "Authorize Failed!!!",
        //         "Please Logout And Login Again!!!",
        //         "text-h5 red--text text-center"
        //     );
        //     this.$router.back();
        // }

        // const router_path = parser.pathname.replace("/", "");

        // const res_auth = await api.getAuthorize(this.userId, router_path);


        // this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
        // this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
        // this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
        // this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;



        // if (!this.authorize_view) {
        //     this.$router.back();
        // }

        // // ----------------- Check Authorize ---------------------------

        // let comp_id = localStorage.getItem(server.COMPANYID);

        // this.userId = localStorage.getItem(server.USER_ID);
        // if (this.userId && api.isLoggedIn()) {
        //     // this.$router.push("/");
        // } else {
        //     this.$store.state.isLogged = false;
        //     this.$router.push("/login");
        // }

        //load data
        try {
            await this.loaddata();
        } catch (err) {
            alert("error")
            console.error(err);
        } finally {
            this.$hideLoader();
        }


    },
    methods: {
        onBlurIcon() {
            if (
                this.dataItem.icon &&
                !this.dataItem.icon.startsWith("mdi-")
            ) {
                this.dataItem.icon = `mdi-${this.dataItem.icon}`;
            }
        },
        async loaddata() {
            const result = await api.getClientTimelineStatus()

            if (result.data && result.data.length > 0) {
                this.mDataArray = result.data
            }
        },
        openMdiIcon() {
            window.open(
                "https://mdi.bessarabov.com/search",
                "_blank"
            );
        },
        opendialogAdd() {
            this.modeActions = "New"
            this.dataItem = {};
            this.dialogAddData = true;
        },
        closeaddItem() {
            this.dataItem = {};
            this.dialogAddData = false;
        },

        openeditItem(data) {
            this.modeActions = "Edit";

            this.dataItem = { ...data };

            this.dialogAddData = true;
        },
        async saveaddItem() {

            // validate status
            if (!this.dataItem.status || !this.dataItem.status.trim()) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please enter Status",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // validate color
            const isValidColor = CSS.supports("color", this.dataItem.color);

            if (!this.dataItem.color || !isValidColor) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Invalid Color Code",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // validate icon color
            const isValidIconColor = CSS.supports("color", this.dataItem.icon_color);

            if (!this.dataItem.icon_color || !isValidIconColor) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Invalid Icon Color Code",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // validate icon
            if (!this.dataItem.icon || !this.dataItem.icon.startsWith("mdi-")) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Invalid MDI Icon",
                    "text-h5 red--text text-center"
                );

                return;
            }

            try {

                this.$showLoader();

                let data = null;

                if (this.modeActions == "New") {

                    const response = await api.createClientTimelineStatus(this.dataItem);

                    data = response.data;

                } else {

                    const { id, ...payload } = this.dataItem;

                    const response = await api.updateClientTimelineStatus(
                        id,
                        payload
                    );

                    data = response.data;
                }

                if (data.success) {

                    this.closeaddItem();

                    this.$store.state.global_dialog = true;

                    this.setupAlertDialog(
                        true,
                        "Success",
                        "Saved successfully",
                        "text-h5 green--text text-center"
                    );

                    await this.loaddata();
                }



            } catch (err) {

                console.error(err);

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Cannot save data",
                    "text-h5 red--text text-center"
                );

            } finally {

                this.$hideLoader();

            }
        },
        setupAlertDialog(status, title, message, text_color) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
        },
        setupAlertDialogPush(status, title, message, text_color, link) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
            this.link = link;
        },

    },
};
